import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import queryKey from "../../../../enumerations/queryKey";
import { applyAgent, getAgentStatus, getAreaCodeList } from "../service";

export const useGetAgentStatus = ({ options }) => {
  return useQuery(
    [queryKey.AGENT_STATUS],
    () =>
      getAgentStatus().then((res) => {
        return res.data.data;
      }),
    {
      ...options,
    },
  );
};

export const useGetAreaCodes = ({ options }) => {
  return useQuery(
    [queryKey.AREA_CODE],
    () =>
      getAreaCodeList().then((res) => {
        const areaCode = res.data.data.map((item) => {
          return {
            value: item.area_code,
            label: `+${item.area_code}`,
          };
        });
        return areaCode;
      }),
    {
      ...options,
    },
  );
};

export const useApplyAgent = () => {
  const cache = useQueryClient();
  return useMutation(
    ({ params }) =>
      applyAgent({ params }).then((res) => {
        return res.data.data;
      }),
    {
      onSuccess: () => {
        cache.invalidateQueries([queryKey.AGENT_STATUS]);
      },
      onError: (error) => {
        console.debug(JSON.stringify("ERR", error));
      },
    },
  );
};
